<script>
import DishCard from './dishCard.vue'
import { apiService } from '@/helpers/api.service';

export default {
    components: { DishCard },
    props: {
        dish: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
        deleteDish(){
            apiService.deleteDishbyId(this.dish._id)
            .then( () => {
                apiService.getStoreById()
                this.$bvModal.hide('deleteDish')
                this.$emit('delete-dish', this.dish)
                window.location.reload();
            })
        }
    },
}
</script>

<template>
    <b-modal id="deleteDish" centered size="lg" hide-footer="true">
        <div class="delete-dish">
            <img src="@/assets/images/delete.svg" alt="delete">
            <h2>¿Eliminar este plato?</h2>
            <p>Una vez que lo elimines, el plato no estará disponible en tu menú y dejarás de recibir pedidos para esta preparación. 
                Recordá que también podés <span>editar</span> el plato.</p>
            <DishCard :dish="dish" class="delete-dish-card"/>
        </div>
        <div class="btn-delete-container">
            <b-button href="#" type="submit" variant="success" class="btn-delete btn-cancel" @click="$bvModal.hide('deleteDish')">
                Cancelar
            </b-button>
            <b-button href="#" type="submit" variant="success" class="btn-delete" @click="deleteDish()">
                Si, eliminar
            </b-button>
        </div>
    </b-modal>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/views/my-dishes/deleteDishModal';
</style>
